import clsx from 'clsx';

import { Typography } from '@/components/ui/typography';

interface Metricprops {
  label: string;
  icon: string;
  children: React.ReactNode;
  color?: 'blue' | 'rose';
}

export function Metric({ label, icon, children, color }: Metricprops) {
  return (
    <div
      className={clsx(
        'shadow-base flex h-[76px] min-w-[180px] shrink-0 grow flex-row items-center gap-4 rounded-lg p-4',
        color === 'blue' && 'bg-fx-blue-50 border-fx-blue border',
        color === 'rose' && 'bg-fx-rose-50 border-fx-rose border',
        !color && 'bg-white',
      )}
    >
      <img src={icon} alt="Metric" />
      <div className="flex flex-col items-start">
        <Typography variant="subtitle1">{label}</Typography>
        {children}
      </div>
    </div>
  );
}
